module.exports = __webpack_public_path__ + "img/swing-comfort-and-joy.8ca66bf0.png";